export enum NAV_TRIGGER_TYPE {
    NEW_SITE_SUPPORT = "newSiteSupport",
    SR_WIDGET_TABLE = "srWidgetTable",
    SR_WIDGET_NAV = "srWidgetNavigation",
    VIEW_CUSTOMER = "viewCustomer",
    NEW_SR_CREATION = "createSR",
    VIEW_CUSTOMER_SR = "viewCustomerSR"
}

export enum CONFIG_TOOL_NAV_TRIGGER {
    USER_REDIRECT = "configToolUserRedirect",
    USER_REDIRECT_TIER1 = "configToolUserRedirectT1",
}